import { AttributeDefinition } from 'domain/experiment/attribute';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrentEntityAttributeDefinitions } from './redux/actions';
import {
  getCurrentEntityAttributeDefinitions,
  getCurrentEntityAttributeDefinitionsError,
  getCurrentEntityAttributeDefinitionsStatus,
} from './redux/selectors';

export const useEntityAttributeDefinitions = (
  organizationName: string,
  projectName: string,
  shortId?: string,
) => {
  const dispatch = useDispatch();

  const attributeDefinitions: AttributeDefinition[] | undefined = useSelector(
    getCurrentEntityAttributeDefinitions,
  );
  const fetchStatus = useSelector(getCurrentEntityAttributeDefinitionsStatus);
  const error = useSelector(getCurrentEntityAttributeDefinitionsError);

  const fetchAttributeDefinitions = React.useCallback(() => {
    if (!shortId) {
      return;
    }

    dispatch(fetchCurrentEntityAttributeDefinitions({ organizationName, projectName, shortId }));
  }, [dispatch, organizationName, projectName, shortId]);

  return {
    attributeDefinitions,
    error,
    fetchAttributeDefinitions,
    fetchStatus,
  };
};

export const useEntityAttributeDefinitionsWithFetching = (
  organizationName: string,
  projectName: string,
  shortId?: string,
) => {
  const result = useEntityAttributeDefinitions(organizationName, projectName, shortId);
  const { fetchAttributeDefinitions } = result;

  React.useEffect(fetchAttributeDefinitions, [fetchAttributeDefinitions]);

  return result;
};
